import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from './auth';

// Endpoints self-scoped del tenant del usuario autenticado (cualquier rol).
// A diferencia de api/tenantsAdmin.js (solo USER_LIFTLOGIC), estos resuelven el
// tenant desde el JWT del request — sirven para que un usuario normal acceda a
// datos de su propio tenant sin endpoints admin.

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

// GET /tenants/me/logo → { tenantId, logo_url } (logo_url ya resuelto al proxy
// /logo-file o URL absoluta, mismo formato que el admin list).
export const getMyTenantLogo = async () => {
  const res = await axios.get(`${API_PATH}/tenants/me/logo`, {
    headers: authHeaders(),
  });
  return res.data;
};
